module.exports={author:"Zachary Schomburg",date:"09/29/2019",publishDate:"09/29/2019",highlighted:!1,tags:"",title:"2 Poems"};